<template>
    <div class="wos__page_index">
        <div class="container-fluid">
            <section class="wos__page-content_index">
                <img src="/assets/images/wos__logo.svg" alt="Wellis Online System logo" width="205">
                <p class="mt-5 mb-3 ml-2">{{apologizeTitle}}</p>
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <p style="font-size:16px; display: block" v-for="(text, index) in apologizeText" :key="index">
                            {{text}}<br>
                        </p>
                    </div>
                </div>
            </section>
            <section class="wos__page-content_index">
                {{(new Date().getFullYear())}} &copy; Wellis Online System <br>
            </section>
        </div>
    </div>
</template>

<script>
    import messages from '../../core/lang/index';

    export default {
        name: "DeadServer",
        data() {
            return {
                titles: [],
                texts: [],
                pos: 0,
                timer: null,
                pingTimer: null,
            }
        },

        created() {
            Object.values(messages).forEach(item => {
                if (item.components && item.components['dead-server'].texts) {
                    this.titles.push(item.components['dead-server'].title);
                    this.texts.push(item.components['dead-server'].texts);
                }
            });

            this.timer = setInterval(() => {
                this.pos = (this.pos + 1) === this.texts.length ? 0 : this.pos + 1;
            }, 5000);
        },

        computed: {
            apologizeTitle() {
                return this.titles[this.pos];
            },

            apologizeText() {
                return this.texts[this.pos];
            }
        }
    }
</script>

<style scoped>

</style>
